export const GET_RECOMMENDATIONS = "GET_RECOMMENDATIONS"
export const GET_RECOMMENDATIONS_SUCCESS = "GET_RECOMMENDATIONS_SUCCESS"
export const GET_RECOMMENDATIONS_BY_CONTROL_ID = "GET_RECOMMENDATIONS_BY_CONTROL_ID"
export const GET_RECOMMENDATIONS_BY_CONTROL_ID_SUCCESS = "GET_RECOMMENDATIONS_BY_CONTROL_ID_SUCCESS"
//
export const POST_RECOMMENDATION = "POST_RECOMMENDATION"
//
export const UPDATE_OPINIONS_VIEW_STATUS = "UPDATE_OPINIONS_VIEW_STATUS"
export const POST_OPINION_RECOMMENDATION = "POST_OPINION_RECOMMENDATION"
//
export const PATCH_RECOMMENDATION = "PATCH_RECOMMENDATION"
